export default {
	facebookAppId: 937149326481576
};